import { tns } from 'tiny-slider/src/tiny-slider';

class LogosSlider {
    constructor(el, prevButton, nextButton) {
        this.el = el;
        this.prevButton = prevButton;
        this.nextButton = nextButton;

        const maxItems = 6;
        const slideCount = this.el.children.length;
        const canLoop = slideCount > maxItems;

        const logosSlider = tns({
            container: this.el,
            items: 1,
            row:2,
            responsive: {
                641: {
                    items: 3,
                    gutter: 20,
                },
                1025: {
                    items: maxItems,
                    gutter: 40,

                }

            },
            autoplay: false,
            autoplayButtonOutput: false,
            mouseDrag: true,
            preventScrollOnTouch: 'auto',
            swipeAngle: false,
            speed: 400,
            controls: true,
            prevButton: this.prevButton,
            nextButton: this.nextButton,
            gutter: 10,
            nav:true,
            navPosition: "bottom",
            loop: canLoop,
        });

        this.enableControlsFocus();

        logosSlider.events.on('indexChanged', () => this.enableControlsFocus());
        logosSlider.events.on('transitionEnd', () => this.enableControlsFocus());

        return logosSlider;
    }

    enableControlsFocus() {
        setTimeout(() => {
            [this.prevButton, this.nextButton].forEach((button) => {
                if (!button) return;

                button.disabled = false;
                button.removeAttribute('disabled');
                button.removeAttribute('tabindex');
                button.setAttribute('tabindex', '0');
                button.removeAttribute('aria-hidden');
            });
        }, 0);
    }
}

export default LogosSlider;